import { render } from "./ProfilesGraph.vue?vue&type=template&id=bc9f9790"
import script from "./ProfilesGraph.vue?vue&type=script&lang=js"
export * from "./ProfilesGraph.vue?vue&type=script&lang=js"

import "./ProfilesGraph.vue?vue&type=style&index=0&id=bc9f9790&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__